import fetchIfNecessary from 'models/fetchIfNecessary';
import SchemaFieldSelectorActions from 'registry/schema-field-selector/SchemaFieldSelectorActions';

export default class SchemaFieldSelectorManager {
  static fetchForRegistry(registryId: string): Promise<void> {
    return fetchIfNecessary('schemaFieldSelectorsForRegistry', registryId, () =>
      SchemaFieldSelectorActions.fetch(registryId)
    );
  }

  static fetchForAllRegistries(): Promise<void> {
    return fetchIfNecessary('schemaFieldSelectorsForAllRegistries', 'all', () =>
      SchemaFieldSelectorActions.fetch()
    );
  }
}
